import React from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// @material-ui/icons
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

// core components
import GridContainer from '../../../components/Grid/GridContainer.js';
import GridItem from '../../../components/Grid/GridItem.js';
import InfoArea from '../../../components/InfoArea/InfoArea.js';

import styles from '../../../assets/jss/material-kit-react/views/landingPageSections/productStyle.js';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../LandingPage.css';
import goals from '../../../assets/img/slides/goals.png';
import goalsdashboard from '../../../assets/img/slides/goalsdashboard.png';
import newgoal from '../../../assets/img/slides/newgoal.png';

const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify='center'>
        <GridItem xs={12} sm={12} md={8}>
          <h1 className={classes.title}>What are we?</h1>
          <h4 className={classes.description}>
            We are a planning platform aiming to be the most realistic,
            result-oriented and dynamic with respect to what you learn and the
            changes in circumstances. Plato is our inspiration for seeking
            reality and distinguishing reality from its shadow, famously known
            as <i>Allegory of the Cave</i>.
          </h4>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title='Goal Setting'
              icon={TrackChangesIcon}
              iconColor='info'
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title='Habit Development Planning'
              icon={AllInclusiveIcon}
              iconColor='success'
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title='Budget Planning'
              icon={AccountBalanceIcon}
              iconColor='warning'
              vertical
            />
          </GridItem>
        </GridContainer>
        <Carousel
          autoPlay
          width='600px'
          style={{ position: 'relative', left: '50%', margin: 'auto' }}
        >
          <div>
            <img alt='' src={goals} />
            <p
              className='legend'
              style={{
                backgroundColor: 'transparent',
                color: 'black',
                opacity: '100%',
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              All of your goals in one place
            </p>
          </div>
          <div>
            <img alt='' src={goalsdashboard} />
            <p
              className='legend'
              style={{
                backgroundColor: 'transparent',
                color: 'white',
                opacity: '100%',
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              Visualize your goal with our cool dashboard
            </p>
          </div>
          <div>
            <img alt='' src={newgoal} />
            <p
              className='legend'
              style={{
                backgroundColor: 'transparent',
                color: 'black',
                opacity: '100%',
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              Set goals with our interactive form (powered by TypeForm)
            </p>
          </div>
        </Carousel>
      </div>
    </div>
  );
}
